import ErrorFatal from './ErrorFatal'

export default ErrorFatal
